import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

const StartNewFisheryDialog = (props) => (
  <Dialog
    title="Start a New Fishery"
    modal={false}
    open={props.open}
    onRequestClose={props.onRequestClose}
    actions={[
      <FlatButton label="Cancel" onClick={props.onRequestClose} />,
      <RaisedButton primary={true} onClick={() => {
        props.clearResponse();
        setTimeout(() => {
          props.router.push("/");
          props.onRequestClose();
        }, 100);
      }} label="New Fishery" />
    ]}
  >
    {
      props.notSaved ? <span><b>Your current response has not been saved.</b> Are you sure you want to start the questionnaire without saving it?</span> :
        props.readOnly ? "Are you sure you'd like to start a new fishery? You won't be able to return to this one." : <span>Are you sure you would like to start a new fishery? You can always come back to these results by using the link sent to your email address.</span>
    }
  </Dialog>
);

export default StartNewFisheryDialog;
